export const portugueseLocal = {
    "translation": {
        "LOAD_USER_INFO": "Validando dados",
        "ACCESS_DIR": "Acessos Recentes",
        "RES_INFO": "Info. ",
        "AUDIT_INFO": "status de auditoria",
        "AUDIT_DOCS": "Auditoria de documentos",
        "AUDIT_INFO_SHORT": "Informações de auditoria",
        "AUDIT_INFO_LONG": "Informações de auditoria",
        "CONT": "Contratante",
        "APPROVEDS": "aprovado",
        "APPROVED": "aprovado",
        "REJECTED": "Recusou",
        "REJECTEDS": "rejeitado",
        "PDG_EVAL": "Em avaliação",
        "AUDIT_DOC": "Auditoria de documentos",
        "DOC": "Documento",
        "DOCS_CONT": "Documentos da Contratada",
        "DOCS_EMPS": "documentos do empregado",
        "DOCS_VEHS": "documentos do veículo",
        "DOCS": "Documentos",
        "SBT_QUOT": "Enviar cotas",
        "SBT_WHIT_PP": "apresentação parcial",
        "SBT_WHIT_PP_CRITERION": "O cálculo das apresentações parciais considera o número máximo de planos de pagamento ativos configurados",
        "DATE": "Data",
        "STATE_DOCTION": "estado do documento",
        "STATE_RESS": "status do recurso",
        "STATE_RES_ENTRY": "Status do recurso para renda",
        "DOC_DUE_BY_CRITERION": "Documentação devida por critérios",
        "DOCTION": "Documentação",
        "DOC_REQ": "Documentação necessária",
        "EMP": "Funcionário",
        "EMPS": "Funcionários",
        "VEH": "Veículo",
        "VEHS": "Veículos",
        "CONTRACT": "Contrato",
        "CONTRACTS": "contratos",
        "CONTRACTS_MENU": "Contratos",
        "RPT_SUB_HIS": "Histórico de envio",
        "RPT_SUB_STS": "status de submissão",
        "DOC_SUB": "Envio de documentos",
        "MCONT": "Empreiteiros",
        "MCONT_RES_STS": "status do recurso",
        "SCONT_SUB_STS": "status de submissão",
        "FILTERS": "filtros",
        "SCH_FILT": "Filtro",
        "FILT_FOR": "Filtrar por",
        "REQ_DOC": "Documento necessário",
        "SEARCH_FILTER": "Procure algum filtro...",
        "REG_NUM": "Número de registros",
        "COPY": "cópia de",
        "COPIED": "copiado",
        "DOWNLOAD_PAGE": "página de download",
        "DOWNLOAD_ALL": "Baixar tudo",
        "DOWNLOAD": "Descarga",
        "CRITERION": "Critério",
        "CRITERION_DESCRIP": "Detalhe do critério",
        "DOC_COD": "Código do documento",
        "DOC_NAME": "Nome do documento",
        "DOC_PROX_EXRE": "Doc Próx. ",
        "SEARCH_VEH": "Pesquisar veículo",
        "SEARCH_EMP": "Procurar Funcionário",
        "SEARCH": "Procurar",
        "INFO_RES": "Informações do recurso",
        "AUDIT_RESS": "Auditoria de recursos",
        "RES": "Recurso",
        "RESS": "Recursos",
        "TPE_RES": "Tipo de recurso",
        "ID": "EU IA",
        "PATENT": "Patente",
        "ID_PATENT": "ID/Patente",
        "NAME": "Nome",
        "BND_MOD": "Fazer modelo",
        "NAME_BND_MOD": "Nome/ Marca/ Modelo",
        "STION_RES": "status do recurso",
        "STION": "Situação",
        "STE_CURR_DATE": "Estado até o momento",
        "STE_APTDE": "Aptidão",
        "EXRE": "Expiração",
        "PNT_DOC": "Enviar documento",
        "STATE": "Estado",
        "CONTRACTS_STATUS": "status do contrato",
        "EMP_PHOLDER_ENTRY": "Pesquise por ID ou nome",
        "VEH_PHOLDER_ENTRY": "Pesquise por patente ou nome",
        "APT_ENTRY": "Adequado",
        "UN_APT_ENTRY": "impróprio",
        "STFING": "satisfatório",
        "UN_STFING": "Insatisfatório",
        "CUIL": "cuil",
        "RBO": "Cabeçalho",
        "RANK": "Classificações",
        "ACTIVE": "Ativo",
        "INACTIVE": "Parado",
        "LOW": "Baixo",
        "LASTS": "Durar",
        "DAYS": "Dias",
        "OPENING": "Abertura",
        "ENTRY": "Renda",
        "CHANGE": "Mudar",
        "APT": "Adequado",
        "PART_APT": "ajuste parcial",
        "UN_APT": "impróprio",
        "PENDING_CLOSE": "brincos de fechamento",
        "VALTY": "Validade da autorização",
        "VALIDITY": "Validade da autorização",
        "EXIT": "Sair",
        "SUBMITED": "apresentado",
        "PDING": "Brinco",
        "PDING_OP": "Pendente (Atrasado e não apresentado)",
        "NOT_SUBMITED": "Não comparência",
        "EXPIRED": "Derrotado",
        "CREDENTIAL": "Credencial",
        "APPLY": "Aplicar",
        "SHOW_MORE": "Mostre mais",
        "NO_DATA": "Não há dados para mostrar",
        "YES": "Sim",
        "NO": "Não",
        "DEPNDS_REL": "Média de dependência",
        "SUB_CONTRACT": "terceirizado",
        "CONCEPT": "Conceito",
        "OTHER": "Outro",
        "UP_DATE": "Data de quitação",
        "TYPE_CONTRACT": "tipo de contrato",
        "IS_DRIVER": "é motorista",
        "CODE": "Código",
        "DESCRIPTION": "Descrição",
        "CONCEPT_DESCRIP": "Descrição do conceito",
        "DATE_SINCE": "Data de",
        "DATE_UNTIL": "Data para",
        "DATE_PRESENT": "Data de apresentação",
        "DATE_AUDIT": "Data da auditoria",
        "CORRESPONDING_TO": "Correspondente a ",
        "EVENTUALITY": "Eventualidade",
        "VALUE": "Valor",
        "MORE_INFO": "Mais Informações",
        "EXCEPTION_UNTIL": "Você pode inserir até ",
        "STATUS_TO_ENTRY": "estado do recurso",
        "SEND_TO": "Envie todos",
        "SEND": "Enviar",
        "LAST_ONE_DAYS": "últimas 24 horas",
        "LAST_SEVEN_DAYS": "Últimos 7 dias",
        "LAST_SEVENTEEN_DAYS": "últimos 15 dias",
        "LAST_THRITY_DAYS": "Últimos 30 dias",
        "SELECT": "Escolher",
        "HELLO": "Olá!",
        "FILTER_DOCS": "Filtros de documento",
        "FILTER_RES": "Filtros de recursos",
        "NO_DATA_SEARCH": "Não há resultados de pesquisa.",
        "SHOW_ALL": "Mostre tudo",
        "ERROR_PAGE_TITTLE": "Erro, página não encontrada",
        "ERROR_TENANT_TITTLE": "Erro, a instância não está configurada",
        "ERROR_PAGE_MESSAGE": "Desculpe, a página que você solicitou não pôde ser encontrada. ",
        "ERROR_TENANT_MESSAGE": "Entre em contato com a Exactian.",
        "ERROR_PAGE_GO_TO": "De volta ao topo",
        "ERROR_TENANT_GO_TO": "Ir para Exactian",
        "NO_DOCUMENTS_LEFT": "Nenhuma documentação devida",
        "NO_DATA_PERIOD_LEFT": "Não há informações no período selecionado",
        "ERASE": "Excluir",
        "FIRSTWORD_MSG_LOAD_DOCS_STATUS": "Imprensa",
        "FIRST_KEY_WORD_LOAD_DOCS_STATUS": "Carregar informações",
        "SECONDWORD_MSG_LOAD_DOCS_STATUS": "Para ver este gráfico ou",
        "SECOND_KEY_WORD_LOAD_DOCS_STATUS": "Detalhe geral",
        "THIRDWORD_MSG_LOAD_DOC_STATUS": "Para ver mais informações.",
        "MSG_NOT_TO_GO": "* Ao iniciar o carregamento, você não deve sair da tela.",
        "PAST_DUE_HISTORY": "Documentação da dívida",
        "ALL_APTITUDES": "todas as situações",
        "ALL_AUDITS": "todos os estados",
        "ALL_CONTRACTS": "Todos os contratos",
        "ALL_CRITERION": "Todos os critérios",
        "ALL_DOCS": "todos os documentos",
        "ALL_EMP": "Todos os funcionários",
        "ALL_VEH": "Todos os veículos",
        "ALL_OPENINGS": "todas as aberturas",
        "ALL_EVENTIUALITIES": "todas as eventualidades",
        "ALL_RESOURCES": "todos os recursos",
        "ALL_CLASSIFICATION": "Todas as classificações",
        "HISTORY": "Registro",
        "FROM": "De",
        "UNTIL": "Até",
        "PERIOD": "Período",
        "SUBMIT_DOC": "Apresentar documento",
        "AUDITOR": "Auditor",
        "SHOW_DETAIL": "Ver detalhes",
        "GLOBAL_PRESENTATION": "Apresentação geral",
        "INDVIDUAL_PRESENTATION": "Apresentação solo",
        "ATTACH": "Anexar",
        "DELETE": "Eliminar",
        "SHOW_FILE": "Visualizar arquivo",
        "CANCEL": "Cancelar",
        "DATE_RANGE": "Intervalo de datas",
        "SITUATION_HISTORY": "situação histórica",
        "ACCEPT": "Aceitar",
        "LOAD_FILE": "arquivo enviado",
        "SELECT_TWO": "Escolher",
        "OR_DRAG": "ou arraste um documento",
        "ACCEPT_FORMATS": "Formatos suportados",
        "MAX_SIZE": "Tamanho máximo",
        "MAX_SIZE_ERROR": "Arquivo maior que",
        "ACCEPT_FORMATS_ERROR": "Formato de arquivo não aceito",
        "IN_EVALUATION_FROM": "Em avaliação desde",
        "SELECT_TYPERES_O_DOC": "Você deve marcar o tipo de recurso ou um documento",
        "NO_INSTRUCTIONS": "sem instruções",
        "SERVER_ERROR": "Erro de servidor",
        "REPEAT_SUBMIT_ERROR": "Já existe um envio para o documento/recurso/período",
        "ERROR_SUBMIT_TITTLE": "Erro de upload de documento",
        "ERROR_SUBMIT_SERVER": "Ocorreu um problema ao carregar o documento",
        "SUCCESS_SUBMIT_TITTLE": "Preparar!",
        "SUCCESS_SUBMIT_MESSAGE": "O documento foi enviado com sucesso. ",
        "WARNING": "Aviso",
        "REPLACE_WARNING": "Já existe um documento que corresponde a essas datas. ",
        "PRESET_DATE_INFO": "Data definida automaticamente, pode ser modificada",
        "DELETE_NEXT_DOC": "Você está prestes a excluir o seguinte documento:",
        "SURE_TO_CONTINUE": "Tem certeza de que deseja continuar?",
        "NO_DOC_DUE": "Nenhuma documentação devida",
        "DOC_DUE_NUM_PART_ONE": "Documentação devida, no último",
        "DOC_DUE_NUM_PART_TWO": "meses. ",
        "GLOBAL_DOC_UPLOAD": "Carregamento global de documentos",
        "UPLOAD_FILE": "Subir arquivo",
        "CONTINUE": "Continuar",
        "CONFIRM": "confirme",
        "REPLACE_PRES_IF_HAS_DUP": "Substitua a apresentação em caso de duplicação.",
        "TITLE_GLOBAL_DOC_STEP1": "Selecione o tipo de documento que deseja enviar globalmente",
        "TITLE_GLOBAL_DOC_STEP2": "Selecione todos os recursos para os quais deseja carregar o documento previamente escolhido.",
        "FILE_NOT_FOUND": "Arquivo não encontrado.",
        "SELECT_ALL": "selecionar tudo",
        "TITLE_EXP_IMP_STEP2": "Baixe ou carregue o arquivo com os recursos",
        "DOWNLOAD_FILE": "⇬ Fazer download do arquivo",
        "ERROR": "Erro",
        "IMPORT_ERROR_RES_TXT": "Registro(s) que não correspondem à folha de pagamento. ",
        "FILE_HAVE": "O arquivo contém",
        "EXP_IMP_BTN_STEP2": "Exportar/Importar arquivo",
        "UPLOAD_OTHER_FILE": "Carregar outro arquivo",
        "WANT_HAVE_SAMPLE_FILE": "Você quer ter o arquivo de amostra?",
        "TEXT_EXP_IMP_STEP2": "O arquivo de amostra inclui todos os recursos aos quais você pode apresentar o documento previamente escolhido.",
        "SELECTED": "Selecionados",
        "NO_EXPIRATION": "sem caducidade",
        "RESOURCE_INFO": "Detalhe do recurso",
        "EXPORT": "Exportar",
        "GENERAL_REPORT": "Relatório Geral",
        "CONTRACTOR": "Contratante",
        "IMPORT_ERROR_STRUCTURE_TXT": "Verifique se seu arquivo contém uma coluna chamada",
        "NOT_EDIT_COL": "IMPORTANTE!: Não edite o nome das colunas.",
        "ERROR_IMP": "erro de importação",
        "ERROR_FORMAT": "Erro de formato",
        "PREVIEW": "Visualização",
        "Total": "Total",
        "DRIVE": "Ela dirige",
        "BULK_UPLOAD_DETAIL": "Detalhes do upload em massa ",
        "VALTY_WORD": "Validade",
        "DELETE_PRES": "Excluir apresentação",
        "DELETE_PRES_SUCCESS": "A apresentação foi excluída com sucesso!",
        "DELETE_PRES_ERROR": "Não foi possível excluir a apresentação",
        "DELETE_PRES_ERROR_MSG": "Ocorreu um problema ao excluir o arquivo.",
        "OPEN_FILE_IN_NEW_TAB": "O arquivo foi aberto em uma nova guia do navegador.",
        "TOTAL_PRESS": "apresentação completa",
        "DOC_PERIOD": "Documentação correspondente a",
        "SUCCESS_SUBMIT_MESSAGE_TWO": "O documento foi enviado com sucesso.",
        "VALIDITY_DATE": "Data efetiva",
        "VALIDITY_ERROR_MESSAGE": "A data até deve ser maior que a data desde.",
        "USER_NAME": "Do utilizador",
        "PASSWORD": "Senha",
        "HELLO_AGAIN": "Olá de novo!",
        "RECOVER_PASSWORD": "recuperar senha",
        "GET_INTO": "Entrar",
        "ENTER_USER_NAME": "entre com seu nome de usuário",
        "ENTER_PASSWORD": "Coloque sua senha",
        "ERROR_LOGIN_CREDENTIALS": "Credenciais erradas!",
        "ENTER_MAIL": "Digite seu e-mail",
        "CHOOSE_OPENING": "Selecione um",
        "CHANGE_OPENING": "Alterar abertura",
        "CHANGE_BUILDING": "Alterar edifício",
        "ENTER_MAIL_AND_USER_TO_RESET": "Digite seu e-mail e nome de usuário para redefinir a senha",
        "WRONG_USER_ERROR": "O usuário informado não existe",
        "INSTANCE_INFO_ERROR": "Instância não encontrada",
        "CHECK_YOUR_MAIL": "Verifique seu e-mail",
        "WE_SEND_A_MAIL_TO": "Enviamos um e-mail para você",
        "FOR_RESET_PASSWORD": "para que você possa redefinir a senha",
        "DID_NOT_ARRIVE_THE_MAIL": "Não recebeu o e-mail?",
        "REMEMBER_CHECK_SPAM": "Lembre-se de verificar a pasta de spam",
        "RESEND_MAIL": "Reenviar email",
        "CHANGE_MAIL": "Mude o e-mail",
        "WAS_SEND": "Enviado",
        "WELCOME": "Bem-vindo",
        "NEW_PASSWORD": "Nova Senha",
        "MY_ACCOUNT": "Minha conta",
        "REPORTS": "Relatórios",
        "CONFIG": "Configurações",
        "HELP": "Ajuda",
        "LOGGOUT": "cancelar assinar",
        "SCAN_OR_CODE_DNI": "Coloque o celular na frente do código QR ou ID",
        "MANUAL_ENTRY": "Entrada manual",
        "WRITE_ID": "Escreva o número de identificação ou DNI.",
        "PASS_CREATED": "Senha criada com sucesso",
        "ENABLED": "Habilitado",
        "NOT_ENABLED": "Não habilitado",
        "APT_TO_ENTRY": "Apto para entrar",
        "NOT_APT_TO_ENTRY": "Não serve para entrar",
        "STATUS_DETAIL": "Detalhe do estado",
        "SEARCH_CODE_OR_SCAN": "Pesquisar por ID | Número do documento ou digitalizar QR",
        "MAX_EIGHT_CARACT_ALLOW": "Mínimo de 8 caracteres permitidos",
        "TO_USE_CAMERA_NEED_PERMISSIONS": "Para usar o scanner, você precisa das permissões da câmera",
        "ALLOW_USE": "Permitir uso",
        "INSTANCE_NOT_CONFIG_TO_ENTRY": "Instância não configurada para receita",
        "CREATE_PASS": "Criar uma senha",
        "WRITE_NEW_PASS": "Digite uma nova senha para sua conta",
        "CONFIRM_PASS": "Confirme sua senha",
        "MIN_EIGHT_MAX_FIFTY_CARACT": "Mínimo de 8 caracteres e máximo de 50 caracteres",
        "UPPERCASE": "Letra maiúscula",
        "LOWERCASE": "Minúsculas",
        "NUMBER": "Número",
        "EMAIL": "E-mail",
        "VALIDATING": "Validando",
        "SELECT_CONTRACT": "Selecione um empreiteiro",
        "PERSON_ENTRY_WITH": "A pessoa entra com",
        "SELECT_VEH": "Selecione o veículo",
        "ENTRY_DETAIL": "Detalhe da renda",
        "WRITE_VISIT_DATA": "Insira os detalhes da visita",
        "SUCCESS_ACCESS_DESC": "A entrada foi feita com sucesso",
        "VISIT": "Visita",
        "VISITS": "visitas",
        "HOURS": "Horas",
        "RES_BY_OPENINGS": "Recursos para vagas",
        "RES_BY_HOURS": "Recursos por hora",
        "ADDITIONAL_INFO": "Informações adicionais",
        "CLASSIFICATION": "Classificação",
        "COLOR": "Cor",
        "ENGINE_NUMBER": "Número do motor",
        "CHASSIS_NUMBER": "Número do chassi",
        "ASSIGNED": "atribuído",
        "DATE_HOUR_EXIT": "Data e hora da alta",
        "DATE_HOUR_ENTRY": "Data e hora de admissão",
        "HOUR": "Hora",
        "SAVE": "Manter",
        "EDIT": "Editar",
        "DEPARTURE": "Descarga",
        "EXIT_DETAIL": "Detalhe da alta",
        "PERSON_EXIT_WITH": "A pessoa sai com",
        "SUCCESS_EXIT_DESC": "A descarga foi concluída com sucesso",
        "TOKEN_ERROR": "Sessão finalizada",
        "ACCESS_WITH_CAR": "A pessoa entra com veículo próprio ou da empresa.",
        "EXIT_WITH_CAR": "A pessoa sai com veículo próprio ou da empresa.",
        "NEXT": "Seguindo",
        "GET_BACK": "Retornar",
        "CONT_MAIN": "Contratante principal",
        "SCAN_QR_OR_ID": "Escanear QR ou ID",
        "NO_CAR": "sem veículo",
        "NO_CAR_ACCESS": "A pessoa entra sem veículo",
        "NO_CAR_EXIT": "A pessoa sai sem veículo",
        "OBSERVATIONS": "Observações",
        "DENY": "Negar",
        "SCAN_ERROR": "Código escaneado inválido",
        "RES_BY": "Recursos para",
        "RES_OF": "Recursos de",
        "STATUS_ERROR_ACCESS": "Funcionário, o veículo que está sendo inserido não pode ser inserido devido ao status",
        "STATUS_ERROR_ACCESS_VISIT": "A visita que você está tentando inserir não pode ser inserida devido ao seu status",
        "CONCURRENCY_ERROR_ACCESS": "O funcionário, veículo que está tentando entrar já está inserido",
        "CONCURRENCY_ERROR_EXIT": "O funcionário, veículo que está tentando sair não é inserido",
        "CONCURRENCY_ERROR_ACCESS_VISIT": "A visita que você está tentando entrar já está inserida",
        "CONCURRENCY_ERROR_EXIT_VISIT": "A visita que está tentando sair não entra",
        "PARAM_MISSMATCH": "A visita corresponde a um trabalhador ativo ou inapto em licença",
        "VISIT_REASON": "Razão para visitar",
        "EMPLOYEE_NO_ACCESS_ERROR": "O funcionário não está autorizado a entrar",
        "FINISH": "Terminar",
        "VEHICLE_DATA_NO_CONFIRM": "Há informações sobre um veículo não confirmado.",
        "DO_YOU_WANT_TO_ADD": "Deseja adicioná-lo?",
        "ADD": "Adicionar",
        "VEHICLE_DATA_NO_COMPLETED": "Você inseriu informações incompletas para um novo veículo.",
        "DO_YOU_WANT_TO_COMPLETE": "Deseja completar as informações?",
        "COMPLETE": "Completar",
        "FULL_NAME": "Nome completo",
        "ENTER_FULL_NAME_OF_VISIT": "Digite o nome completo da visita",
        "ENTER_VISIT_REASON": "Digite o motivo da visita",
        "ENTITY_MAG_DESC": "Descrição deste tipo de relatório",
        "PARAMS": "Parâmetros",
        "MANDATORY_INFO": "Informação obrigatória",
        "QR_CODE_SCANNER": "Leitor de código QR/ID",
        "QR_CODE_ACTIVE_DESC": "Se estiver ativo, o scanner pode ser usado.",
        "VISIT_ACTIVE_DESC": "Funcionários afastados/inativos com documentação em dívida poderão entrar como visitantes.",
        "PREFERENCES": "Preferências",
        "OPENING_ACTIVE_DESC": "Se estiver ativo, é obrigatório selecionar uma vaga após o login.",
        "ENTITY_MANAGEMENT": "Gestão de entidades",
        "OPENINGS": "aberturas",
        "ENABLE_OPENINGS": "Habilitar vagas no app.",
        "SEARCH_OPENNINGS": "Aberturas de busca",
        "ENTRY_DEPARTURE": "Entrada / Saída",
        "PERMANENCE": "Permanência",
        "TODAY": "Hoje",
        "ALL": "Todos",
        "TYPES": "Tipos",
        "PERMISSIONS_ERROR": "Você não tem permissões, fale com o Administrador.",
        "UNDERSTOOD": "Entendido",
        "RESOURCES_IN_OPENING_ERROR": "A abertura não pode ser desativada pois possui receita cadastrada.",
        "RESOURCES_IN_WITHOUT_OPENING_ERROR": "Erro, há recursos inseridos sem a abertura.",
        "ENTITY_CONFIG": "Configuração da Entidade",
        "PARAMS_CONFIG": "Configuração de parâmetro",
        "DATA_BASICS_CONFIG": "Configuração básica de dados",
        "PREFERENCES_CONFIG": "Configurações de preferência",
        "NO_OPENING": "Sem Abertura",
        "PERMANENCE_TIME": "Tempo de permanência",
        "WRITE_VISIT_VEHICLE_DATA": "Digite os dados do veículo",
        "RES_NAME": "Nome do recurso",
        "TYPE": "Tipo",
        "CONTRACTOR_CUIT": "cuit do empreiteiro",
        "MOVEMENTS": "Movimentos",
        "TIME_ELAPSED": "Tempo transcorrido",
        "BUILDING": "Prédio",
        "AREA": "Área",
        "MINUTES": "Minutos",
        "PLANT_RESOURCES": "Recursos na planta",
        "DOWNLOAD_REPORT": "Baixar relatório",
        "EMP_DETAIL": "Detalhes do funcionário",
        "ENTER_VEHICLE_VISIT_PATENT": "Insira o número da patente",
        "ENTER_VEHICLE_VISIT_MODEL": "Insira o modelo",
        "ENTER_OBSERVATIONS": "Insira as observações",
        "REPORT": "relatório",
        "VEH_DETAIL": "Detalhe do veículo",
        "VIS_DETAIL": "Detalhe da visita",
        "DETAIL": "Detalhe",
        "MOV_DETAIL": "Detalhe dos movimentos",
        "MINUTE": "Minuto",
        "RES_PERMANENCE_DETAIL": "Detalhe da permanência do recurso",
        "EMPLOYEE_NO_ACCESS_OPENING_ERROR": "O recurso não pertence à abertura selecionada",
        "LINK_EXPIRED": "Link expirado",
        "EXCEPTO": "Exceto",
        "RES_ENTERED": "Recursos inseridos",
        "PAGE": "Página",
        "OF": "de",
        "NORMAL_HS": "Horário normal",
        "50%_HS": "Horas extras 50%",
        "100%_HS": "Horas extras 100%",
        "NORMAL_HS_SHORT": "Hs normal",
        "50%_HS_SHORT": "Horas extras 50%",
        "100%_HS_SHORT": "Horas extras 100%",
        "RESOURCE_DATA": "Dados do recurso",
        "USER_ACCESS": "Login do usuário",
        "USER_EXIT": "Saída do usuário",
        "TOTAL_HS": "Horas totais",
        "TOTAL_HS_PER": "Total de horas por",
        "RECORDS": "Registros",
        "BY": "Por",
        "ERROR_TRY_AGAIN": "Ocorreu um erro, por favor tente novamente.",
        "NOT_ENABLE_OPENING_WITHOUT_OPNING": "Você não pode ativá-lo, pois inseriu recursos sem um ",
        "ASSIGNED2": "atribuído",
        "REQUESTS": "Dúvidas",
        "ERROR_DATA_ENTER": "Ocorreu um erro, verifique os dados inseridos",
        "DOWNLOAD_APP": "Atalho de instalação",
        "EMPLOYEE_HAVE_FUTURE_INCOME_ERROR": "O ID consultado corresponde a um funcionário cuja data de ingresso na Exactian é futura",
        "AUTHORIZED_BY": "Autorizado por",
        "CHOOSE_CAMERA": "Selecione uma câmera para digitalizar",
        "NAME_OF_ENTITIES": "Nome das entidades",
        "CONF_NAME_OF_ENTITIES": "Configurações de nome de entidade",
        "CREATE": "Criar",
        "ENTER_DESCRIPTION": "Insira uma descrição",
        "RESOURCES_IN_BUILDING_ERROR": `Você não pode desativar aqueles que possuem entradas registradas.`,
        "CREATED_SUCCESSFULLY": "creado con éxito",
        "EDITED_SUCCESSFULLY": "editado con éxito",
        "DELETED_SUCCESSFULLY": "eliminado con éxito",
        "ARE_YOU_SURE_DELETE": "Tem certeza de que deseja excluir ",
        "CHOOSE_BUILD": "Selecione um",
        "NO_BUILDING": "Sem construção",
        "THE_RESOURCE_IS_ALREADY_IN": "O recurso já foi inserido",
        "NO_ASSIGNMENT": "Sem atribuição",
        "CODE_ALREADY_EXIST": "O código já existe, altere o código.",
        "RESOURCES_IN_BUILDING_ERROR_TO_DELETE": `Não pode ser excluído porque registrou receita.`,
        "NOT_ACCESS_OPENING": `ele não existe ou está desativado.`,
        "BUILDINGS_IN_OPENING": `A ação não pode ser executada porque está atribuída`,
        "THERE_ARE": `Feno`,
        "WITHOUT": `esquerda`,
        "ASSOCIATED": `associado`,
        "CANT_DELETE_FOR_ENTRYS": `Não pode ser excluído porque registrou receita.`,
        "CANT_ENABLE_FOR_ENTRYS": `Não pode ser desativado porque possui renda registrada.`,
        "CANT_DELETE_FOR_ASSIGNED_TO_USER": `Não pode ser excluído porque a entidade está atribuída a um usuário.`,
        "CANT_DELETE_BUILDING_HAS_AREAS_ERROR": `Não pode ser excluído porque possui áreas atribuídas.`,
        "FREE_ACCESS_AREA": "Acesso Gratuito",
        "ACCESS_ONLY_TO": "Acesso somente para",
        "SELECT_PERSON_TO_VISIT": "Selecione a pessoa para visitar",
        "PERSON_VISITED": "Pessoa visitada",
        "SURNAME": "Sobrenome",
        "PERSON_TO_VISIT": "Pessoa a visitar",
        "CONFIG_PERSON_TO_VISIT": "Configuração de pessoas para visitar",
        "SECTORS": "Setores",
        "CONFIG_SECTOR": "Configuração de setores",
        "SECTOR": "Setor",
        "AMOUNT_PEOPLE_ALLOWED": "Número de pessoas permitidas",
        "ALLOW_PEOPLE_TO_VISIT": "Permitir que as pessoas visitem como dados obrigatórios",
        "NOT_EXIST_SECTOR_ERROR": "O setor não existe ou está desativado",
        "NAME_ALREADY_EXIST": "O nome já existe, altere o nome.",
        "DNI_ID_ALREADY_EXIST": "O DNI/ID já existe, altere o DNI/ID",
        "OPENING_HAS_BUILDINGS_ERROR_SELECTED": "Você selecionou uma abertura que contém edifícios. Por favor selecione o edifício.",
        "RESOURCE_IN_VISITED_ERROR": "A pessoa não pode ficar incapacitada porque está sendo visitada.",
        "PERSON_VISITED_ERROR": "A pessoa não pode ser excluída porque já foi visitada.",
        "SECTOR_USED_ERROR": "O setor não pode ser desativado ou excluído porque está em uso.",
        "CANT_DELETE_BUILDING_HAS_PERSON_ERROR": `Ele não pode ser excluído porque designou pessoas para visitá-lo.`,
        "WITHOUT_SECTOR": `Nenhum setor.`,
        "OPENING_WITH_PERSON_ASIGNED_ERROR": `Não pode ser desativado porque tem uma pessoa designada para visitar.`,
        "NOT_ACCESS_OPENING_START": "A entrada não pôde ser concluída porque foi logado sem",
        "NOT_ACCESS_OPENING_START_MID": "e há",
        "NOT_ACCESS_OPENING_MID": "Entrada habilitada. Faça login novamente em uma entrada específica",
        "NOT_ACCESS_OPENING_END": "para poder fazer entradas/saídas.",
        "BUILDINGS_WITHOUT_OPENING_START": "A entrada não pôde ser concluída porque você estava logado sem",
        "BUILDINGS_WITHOUT_OPENING_START_MID": "e há",
        "BUILDINGS_WITHOUT_OPENING_MID": "habilitados. Por favor faça login novamente em um",
        "BUILDINGS_WITHOUT_OPENING_END": "específico para poder fazer entradas/saídas.",
        "NOT_ENABLE_BUILDING_WITHOUT_BUILDING": "Você não pode ativá-lo porque possui recursos inseridos sem um ",
        "MANDATORY_PEOPLE_TO_VISIT_ERROR": 'Por favor configure pelo menos uma "pessoa para visitar"',
        "MAXIMUM_PEOPLE_TO_VISIT_ERROR": "O número de pessoas selecionadas excede a cota permitida",
        "EQUIPMENT_OR_TOOLS": "Equipamentos ou ferramentas",
        "THE_PERSON_ACCESS_WITH_EQUIPMENT_OR_TOOLS": "A pessoa entra com equipamentos ou ferramentas.",
        "SELECT_WITH_EQUIPMENT_OR_TOOLS": "Selecionar equipamento ou ferramenta",
        "EQUIPMENT_OR_TOOLS_SELECTABLE": "Equipamentos/Ferramentas",
        "ADD_INFO_OF_TOOL_OR_EQUIPMENT": "Insira informações adicionais como código ou modelo do equipamento",
        "TYPE_EQUIPMENT_OR_TOOLS": "Tipo de equipamento ou ferramenta",
        "TYPE_EQUIPMENT_OR_TOOL_CREATE_SUCCESSFULLY": "Tipo de equipamento ou ferramenta criada com sucesso",
        "TYPE_EQUIPMENT_OR_TOOL_EDIT_SUCCESSFULLY": "Tipo de equipamento ou ferramenta editado com sucesso",
        "TYPE_EQUIPMENT_OR_TOOL_DELETED_SUCCESSFULLY": "Tipo de equipamento ou ferramenta excluído com sucesso",
        "TYPE_EQUIPMENT_OR_TOOL_NAME_ALREADY_EXIST": "O nome já existe, altere o nome.",
        "TYPE_EQUIPMENT_OR_TOOL_NAME_CANNOT_DISABLED": "Há um recurso inserido sem saída que entrou com este tipo de equipamento",
        "TYPE_EQUIPMENT_OR_TOOL_NAME_CANNOT_DELETE": "O equipamento não pode ser excluído porque já foi usado",
        "CONFIG_EQUIPMENT_OR_TOOLS": "Configurar equipamentos ou tipos de ferramentas",
        "EQUIPMENT_DATA_NO_CONFIRM": "Há informações sobre equipamentos não confirmados.",
        "EQUIPMENT_DATA_NO_COMPLETED": "Você inseriu informações incompletas para um novo veículo.",
        "EQUIPMENT_NOT_EXIST_OR_DISABLED_ERROR": "O tipo de equipamento selecionado não existe ou está desabilitado",
        "NO_EQUIPMENT": "Sem equipamento",
        "THE_ACCESS_RECORD_WAS_MODIFY_AT_THE_DATE": "A data de entrada foi modificada no dia",
        "THE_EXIT_RECORD_WAS_MODIFY_AT_THE_DATE": "A data de saída foi modificada no dia",
        "VIEW_DUE_DOC": "Ver documentação pendente",
        "DUE_DOC_OF": "Documentação devida por",
        "DUE_DOC_OF_THE_RESOURCE": "Devida documentação do recurso",
        "CANT_ADD_VEH_WITH_THE_SAME_PATENT": "Você não pode adicionar o veículo porque já existe um com a mesma placa.",
        "FILTER_MORE_FOR_DOWNLOAD": "Filtrar mais para baixar o relatório",
        "CANNOT_CREATE_THE": `Não pode crease a`,
        "CANNOT_CREATE": `Não pode crearse la`,
        "BECAUSE_EXISTING_RESOURCES_IN_THE": "porque os recursos inseridos existem",
        "BECAUSE_EXISTING_RESOURCES_IN": "porque existem recursos inseridos no",
        "WHITOUT": "Sem",
        "CANNOT_ENABLE_THE": `Não pode habilitarse o`,
        "CANNOT_ENABLE": `Não pode habilitarse la`,
        "SHOW_CONTRACTS_DETAILS": `Ver Detalhes dos contratos`,
        "CONTRACTS_DETAILS": `Detalhes dos contratos`,
        "EMP_HAS_NOT_CONTRACTS_ASSIGNED": `O empregado não está atribuído a nenhum contrato`,
        "VEH_HAS_NOT_CONTRACTS_ASSIGNED": `O veículo não está atribuído a nenhum contrato`,
        "INVALID_DATE_MODIFICATION": "A data não pode ser modificada porque geraria um conflito com outros movimentos existentes.",
        "PRIVACY_POLICY": "Política de privacidade",
        "ENTRIES": "Entradas",
        "AREA_SELECT": "Selecionar área",
        "MANDATORY_AREA_SELECT": "É necessário especificar a área e a opção 'Acesso livre' não estará disponível.",
        "EDITED_BY": "Editado por",
        "REASON": "Motivo",
        "DATE_SINCE_CANT_BE_MORE_THAN_UNTIL_DATE": "A data desde não pode ser maior que a data até",
        "DATE_RANGE_CANT_BE_MORE_THAN_ONE_YEAR": "O intervalo de datas não pode ser maior que 1 ano",
        "DATE_RANGE_CANT_BE_FUTURE": "O intervalo de datas não pode ser futuro",
        "CONSIDER_CONTRACTS_FOR_RESOURCE_APTITUDE":"Considerar contratos para definir aptitud do recurso",
        "CONTRACTS_FOR_RESOURCE_APTITUDE_DESC":"Ao habilitar esta opção, o aplicativo de entrada considerará o status de todos os contratos do recurso para definir se ele está apto ou não apto para ingressar.",
        "DUE_DOC_CONTRACTS": "Documentação devida de contratos",
        "CONTRACTS_CONSIDERED_FOR_ENTRY": "O status dos contratos é considerado para o ingresso.",
        "CONTRACTS_NOT_CONSIDERED_FOR_ENTRY": "O status dos contratos não é considerado para o ingresso.",
        "CONTRACTS_CONT_STATUS_CONSIDERED_ENTRY_EMP": "O status dos contratos do contratante é considerado para o ingresso, mesmo sem atribuição ao funcionário.",
        "CONTRACTS_CONT_STATUS_CONSIDERED_ENTRY_VEH": "O status dos contratos do contratante é considerado para o ingresso, mesmo sem atribuição ao veículo.",
        "CONTRACT_DATE_VALIDITY_TOOLTIP": "A data corresponde à vigência do contrato",
        "CONTRACT_DATE_RESOURCE_ASSIGNMENT_TOOLTIP": "A data corresponde à atribuição do recurso ao contrato",
    }
}

